var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.typeNetworkSelected == "facebook" &&
    _vm.filesNetwork.length == 1 &&
    _vm.filesNetwork[0].info.type2 == "video"
    ? _c("renderReelFacebook", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          musicName: null,
          description: _vm.textContentConverted,
          modes: _vm.modes,
          mentions: _vm.mentions,
          positionFormOverlay: _vm.positionFormOverlay,
          place: _vm.place,
          personsIdentified: _vm.personsIdentified,
          collaborators: _vm.collaborators,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "facebook"
    ? _c("renderPostFacebook", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          text: _vm.textContentConverted,
          comments: _vm.commentsConverted,
          datePost: _vm.datePost,
          modes: _vm.modes,
          snippet: _vm.snippet,
          mentions: _vm.mentions,
          place: _vm.place,
          positionFormOverlay: _vm.positionFormOverlay,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "instagram" &&
      _vm.filesNetwork.length == 1 &&
      _vm.filesNetwork[0].info.type.startsWith("video/")
    ? _c("renderReelInstagram", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          music: _vm.music,
          description: _vm.textContentConverted,
          modes: _vm.modes,
          mentions: _vm.mentions,
          positionFormOverlay: _vm.positionFormOverlay,
          place: _vm.place,
          personsIdentified: _vm.personsIdentified,
          collaborators: _vm.collaborators,
          products: _vm.products,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "instagram"
    ? _c("renderPostInstagram", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          text: _vm.textContentConverted,
          comments: _vm.commentsConverted,
          datePost: _vm.datePost,
          modes: _vm.modes,
          personsIdentified: _vm.personsIdentified,
          collaborators: _vm.collaborators,
          music: _vm.music,
          place: _vm.place,
          ratio: _vm.ratio,
          mentions: _vm.mentions,
          products: _vm.products,
          positionFormOverlay: _vm.positionFormOverlay,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "linkedin"
    ? _c("renderPostLinkedin", {
        attrs: {
          medias: _vm.filesNetwork,
          survey: _vm.survey,
          files: _vm.files,
          pages: _vm.pagesEdited,
          text: _vm.textContentConverted,
          comments: _vm.commentsConverted,
          datePost: _vm.datePost,
          snippet: _vm.snippet,
          mentions: _vm.mentions,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "threads"
    ? _c("renderPostThreads", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          text: _vm.textContentConverted,
          comments: _vm.commentsConverted,
          datePost: _vm.datePost,
          snippet: _vm.snippet,
          mentions: _vm.mentions,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "twitter"
    ? _c("renderPostTwitter", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          text: _vm.textContentConverted,
          comments: _vm.commentsConverted,
          datePost: _vm.datePost,
          snippet: _vm.snippet,
          mentions: _vm.mentions,
          verifiedMode: _vm.pages.every(
            (page) =>
              page.story_config && page.story_config.verified_type !== "none"
          ),
          tweetSplitting: _vm.formData.formDataNetwork.twitter.tweetSplitting
            ? _vm.formData.formDataNetwork.twitter.tweetSplitting.active
            : false,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "bluesky"
    ? _c("renderPostBluesky", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          text: _vm.textContentConverted,
          comments: _vm.commentsConverted,
          datePost: _vm.datePost,
          snippet: _vm.snippet,
          mentions: _vm.mentions,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "tiktok"
    ? _c("renderPostTiktok", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          title: _vm.textContentConverted
            ? Array.from(_vm.textContentConverted)
                .slice(0, 90)
                .join("")
                .split(/<br\s*\/?>|<\/br>|\n/i)[0]
            : undefined,
          text: _vm.textContentConverted
            ? Array.from(
                _vm.textContentConverted
                  .split(/<br\s*\/?>|<\/br>|\n/i)
                  .slice(1)
                  .join("\n")
              )
                .slice(0, 4000)
                .join("")
            : undefined,
          mentions: _vm.mentions,
          modes: _vm.modes,
          music: _vm.music,
          positionFormOverlay: _vm.positionFormOverlay,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "google"
    ? _c("renderPostGoogle", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          text: _vm.textContentConverted,
          datePost: _vm.datePost,
          snippet: _vm.snippet,
          mentions: _vm.mentions,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "telegram"
    ? _c("renderPostTelegram", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          text: _vm.textContentConverted,
          comments: _vm.commentsConverted,
          datePost: _vm.datePost,
          snippet: _vm.snippet,
          mentions: _vm.mentions,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "pinterest"
    ? _c("renderPostPinterest", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          title: _vm.textContentConverted
            ? Array.from(
                _vm.textContentConverted.split(/<br\s*\/?>|<\/br>|\n/i)[0]
              )
                .slice(0, 100)
                .join("")
            : undefined,
          text: _vm.textContentConverted
            ? _vm.textContentConverted
                .split(/<br\s*\/?>|<\/br>|\n/i)
                .slice(1)
                .join("\n")
            : undefined,
          datePost: _vm.datePost,
          snippet: _vm.snippet,
          mentions: _vm.mentions,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "youtube" &&
      (!_vm.filesNetwork.length ||
        _vm.filesNetwork[0].info.aspectRatio == 0.5625)
    ? _c("renderShortYoutube", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          musicName: null,
          description: _vm.textContentConverted,
          mentions: _vm.mentions,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm.typeNetworkSelected == "youtube"
    ? _c("renderPostYoutube", {
        attrs: {
          medias: _vm.filesNetwork,
          pages: _vm.pagesEdited,
          title: _vm.textContentConverted
            ? Array.from(_vm.textContentConverted)
                .slice(0, 100)
                .join("")
                .split(/<br\s*\/?>|<\/br>|\n/i)[0]
            : undefined,
          text: _vm.textContentConverted
            ? _vm.textContentConverted
                .split(/<br\s*\/?>|<\/br>|\n/i)
                .slice(1)
                .join("\n")
            : undefined,
          comments: _vm.commentsConverted,
          datePost: _vm.datePost,
          mentions: _vm.mentions,
        },
        on: { clickPage: _vm.clickPageInRenderPost },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }